import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Breadcrumb,
  BreadcrumbItem
} from "reactstrap";
import Select from 'react-select';
import { Link } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomDatePicker from "common/CustomDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchDepartments, createCircularRequest } from "store/actions";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import Swal from "sweetalert2";
const Circular = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);

  const alphaNumSpecial100Regex = /^[A-Za-z0-9\s.,\-/#()]+$/;
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    employees,
    departments,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    departments: state.DepartmentMaster?.departments ?? [],

    loading: state.EmployeeCircularReducer?.loading || state.EmployeeDetailsReducer?.loading || state.DepartmentMaster?.loading,
    error: state.EmployeeCircularReducer?.error || state.EmployeeDetailsReducer?.error || state.DepartmentMaster?.error,
    success: state.EmployeeCircularReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    dispatch(fetchDepartments(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      formik.resetForm()
      setFileKey(Date.now());
    }
  }, [authDetails, success, dispatch]);

  const [toType, setToType] = useState("Select All");
  const [options, setOptions] = useState([]);
  const [fileKey, setFileKey] = useState(Date.now());

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      date: "",
      subject: "",
      communicationOptions: [],
      toType: "Select All",
      selectedOptions: [],
      file: null,
      content: "",
    },
    validationSchema: Yup.object({
      date: Yup.string()
        .nullable()
        .required("Date is required"),

      subject: Yup.string()
        .nullable()
        .required("Subject is required").max(100,"Subject must not exceed 100 Characters").matches(alphaNumSpecial100Regex,"Only Alphabets numeric and special characters are allowed"),

      communicationOptions: Yup.array()
        .min(1, "Select at least one communication method"),

      toType: Yup.string()
        .nullable()
        .required("Recipient type is required"),

      selectedOptions: Yup.array()
        .nullable()
        .when("toType", {
          is: (val) => val !== "Select All",
          then: (schema) =>
            schema.min(1, "Select at least one option"),
          otherwise: (schema) => schema, // No validation if "Select All"
        }),

      file: Yup.mixed()
        .nullable()
        .test(
          "fileType",
          "Only PDF files are allowed",
          (value) => !value || value.type === "application/pdf"
        ),

      content: Yup.string()
        .nullable()
        .required("Content is required"),
    }),
    onSubmit: (values) => {
      const formValues = values;

      const employee = formValues.toType === "Employee" ? "1" : "0";
      const depart_id = formValues.toType === "Department" ? "1" : "0";
      const all = formValues.toType === "Select All" ? "1" : "0";

      const select_items = formValues.selectedOptions.map(opt => opt.value).join(",");

      console.log('select_items > ', select_items)

      const sms = formValues.communicationOptions.includes("SMS") ? "1" : "0";
      const mail = formValues.communicationOptions.includes("Email") ? "1" : "0";
      const notifications = formValues.communicationOptions.includes("Notification") ? "1" : "0";

      // Create new FormData instance
      const formData = new FormData();

      // Append all values
      formData.append("date", formValues.date || "");
      formData.append("subject", formValues.subject || "");
      formData.append("employee", employee);
      formData.append("depart_id", depart_id);
      formData.append("all", all);
      formData.append("select_items", select_items);
      formData.append("create_by", authDetails?.user_id);
      formData.append("message", formValues.content || "");
      formData.append("sms", sms);
      formData.append("mail", mail);
      formData.append("notifications", notifications);

      // Append file if any
      // if (formValues.file && Object.keys(formValues.file).length > 0) {
      //   formData.append("circular", formValues.file);
      // }
      if (values.file) {
        formData.append("circular", values.file);
      }
      dispatch(createCircularRequest(formData))
    },
  });


  const handleToTypeChange = (event) => {
    const selectedType = event.target.value;

    // Set Formik value
    formik.setFieldValue("toType", selectedType);
    formik.setFieldValue("selectedOptions", []);

    // Set local state
    setToType(selectedType);
    // setSelectedOptions([]);

    if (selectedType === "Department") {
      setOptions(departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname })));
    } else if (selectedType === "Employee") {
      setOptions(employees);
    } else {
      setOptions([]);
    }
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   // Handle form submission logic here
  //   console.log("Form submitted");
  // };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  const handleCancel = async () => {
    // If form not changed, reset silently
    if (!formik.dirty) {
      formik.resetForm();
      setFileKey(Date.now());
      setToType("Select All");
      return;
    }

    const result = await Swal.fire({
      title: "Confirm Cancel",
      text: "All entered data will be cleared. Do you want to continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      confirmButtonColor: "rgb(145, 73, 234)",
      cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) return;

    formik.resetForm();
    setFileKey(Date.now());
    setToType("Select All");
  };
  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        {/* Breadcrumbs */}
        <Breadcrumbs title="Employee" breadcrumbItem="Employee Circular" />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-3">
                <Col md="4">
                  <FormGroup>
                    <Label for="date">
                      Date <span className="text-danger">*</span>
                    </Label>
                    {/* <Input
                      id="date"
                      name="date"
                      type="date"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.date}
                      invalid={formik.touched.date && Boolean(formik.errors.date)}
                    /> */}
                    <CustomDatePicker
                      value={formik.values.date}
                      onChange={(date) => formik.setFieldValue("date", date)}
                      onBlur={() => formik.setFieldTouched("date", true)}
                      disablePast={true}
                    />
                    {formik.touched.date && formik.errors.date && (
                      <div className="text-danger">{formik.errors.date}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label for="subject">
                      Subject <span className="text-danger">*</span>
                    </Label>
                    <Input
                      id="subject"
                      name="subject"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      maxLength={100}
                      value={formik.values.subject}
                      invalid={
                        formik.touched.subject && Boolean(formik.errors.subject)
                      }
                    />
                    {formik.touched.subject && formik.errors.subject && (
                      <div className="text-danger">{formik.errors.subject}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="4" style={{ minHeight: "100%", alignContent: "center" }} >
                  <FormGroup>
                    <Label>
                      Communication Type <span className="text-danger">*</span>
                    </Label>
                    <div className="d-flex align-items-center gap-1">
                      <div className="form-check form-check-inline d-flex align-items-center gap-2">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          name="communicationOptions"
                          id="sms"
                          value="SMS"
                          onChange={formik.handleChange}
                          checked={formik.values.communicationOptions.includes("SMS")}
                        />
                        <Label className="form-check-label" for="sms">
                          SMS
                        </Label>
                      </div>
                      <div className="form-check form-check-inline d-flex align-items-center gap-2">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          name="communicationOptions"
                          id="email"
                          value="Email"
                          onChange={formik.handleChange}
                          checked={formik.values.communicationOptions.includes("Email")}
                        />
                        <Label className="form-check-label" for="email">
                          Email
                        </Label>
                      </div>
                      <div className="form-check form-check-inline d-flex align-items-center gap-2">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          name="communicationOptions"
                          id="notification"
                          value="Notification"
                          onChange={formik.handleChange}
                          checked={formik.values.communicationOptions.includes("Notification")}
                        />
                        <Label className="form-check-label" for="notification">
                          Notification
                        </Label>
                      </div>
                    </div>
                    {formik.touched.communicationOptions && formik.errors.communicationOptions && (
                      <div className="text-danger">{formik.errors.communicationOptions}</div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-3">

                <Col md="4">
                  <FormGroup>
                    <Label></Label>
                    <div className="d-flex flex-wrap align-items-center gap-1">
                      <div className="form-check form-check-inline">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="toType"
                          id="employee"
                          value="Employee"
                          onChange={handleToTypeChange}
                          checked={formik.values.toType === "Employee"}
                        />
                        <Label className="form-check-label" for="employee">
                          Employee
                        </Label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="toType"
                          id="department"
                          value="Department"
                          onChange={handleToTypeChange}
                          checked={formik.values.toType === "Department"}
                        />
                        <Label className="form-check-label" for="department">
                          Department
                        </Label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="toType"
                          id="selectAll"
                          value="Select All"
                          onChange={handleToTypeChange}
                          checked={formik.values.toType === "Select All"}
                        />
                        <Label className="form-check-label" for="selectAll">
                          Select All
                        </Label>
                      </div>
                    </div>
                  </FormGroup>
                </Col>

                {toType !== "Select All" && (
                  <Col md="4">
                    <FormGroup>
                      <Label for="options"> 
                        {toType} <span className="text-danger">*</span>
                      </Label>
                      <Select
                        id="options"
                        isMulti
                        options={options}
                        styles={SelectcustomStyles}
                        closeMenuOnSelect={false}
                        className="hrms-select"
                        classNamePrefix="hrms-select"
                        value={formik.values.selectedOptions} // Link to Formik values
                        onChange={(selected) => formik.setFieldValue("selectedOptions", selected)} // Update Formik value
                      />
                      {formik.touched.selectedOptions && formik.errors.selectedOptions && (
                        <div className="text-danger">{formik.errors.selectedOptions}</div>
                      )}
                    </FormGroup>
                  </Col>
                )}

                <Col md="4">
                  <FormGroup>
                    <Label for="fileUpload">
                      File Upload <span className="text-muted">(PDF only)</span>
                    </Label>
                    <Input
                      id="fileUpload"
                      key={fileKey} 
                      name="file"
                      type="file"
                      accept=".pdf"
                      onChange={(event) =>
                        formik.setFieldValue("file", event.currentTarget.files[0])
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label for="content">Content</Label>
                    <div style={{ boxShadow: '0 0 15px rgba(0, 0, 0, 0.08)' }}>
                      <CKEditor
                        key={formik.values.content === "" ? "reset" : "editor"}
                        className="shadow"
                        editor={ClassicEditor}
                        config={{
                          placeholder: 'Enter your content here...',
                        }}
                        // onReady={editor => {
                        //   // You can store the "editor" and use when it is needed.
                        //   console.log('Editor is ready to use!', editor);
                        // }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          formik.setFieldValue("content", data); // This is needed
                        }}
                      // onBlur={(event, editor) => {
                      //   console.log('Blur.', editor);
                      // }}
                      // onFocus={(event, editor) => {
                      //   console.log('Focus.', editor);
                      // }}
                      />
                      {formik.touched.content && formik.errors.content && (
                        <div className="text-danger">{formik.errors.content}</div>
                      )}
                    </div>
                  </FormGroup>
                </Col>
              </Row>
                {canCreate && (
                  <Row className="mt-3">
                    <Col className="text-end">
                      <Button type="submit" className="btn button-send me-2">
                        <i className="fas fa-envelope me-1" /> Send
                      </Button>

                     <Button
                        type="button"
                        className="btn button-cancel"
                        onClick={handleCancel}
                      >
                        <i className="fas fa-sync me-1" /> Cancel
                      </Button>
                    </Col>
                  </Row>
                )}
              
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div >
  );
};

export default Circular;
